import { memo } from 'react';

import { PlusIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { useAirModal } from '@air/provider-modal';

import { CreateBoardModal } from '~/components/Modals/CreateBoardModal';
import { BOARDS_SELECT_EMPTY_OPTION } from '~/constants/BoardSearch';
import { intercomIDs } from '~/constants/intercomIDs';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { canCreateBoard } from '~/utils/permissions/boardPermissions';

export const CurrentWorkspaceNavCreateBoardButton = memo(() => {
  const { data: permissions } = useCurrentWorkspacePermissionsContext();
  const canCreateRootBoards = canCreateBoard(permissions);
  const [showCreateBoardModal] = useAirModal(CreateBoardModal);

  if (!canCreateRootBoards) {
    return null;
  }

  return (
    <Button
      appearance="ghost"
      className="w-full justify-start"
      color="gray"
      data-testid="CREATE_BOARD_BUTTON_END"
      data-intercomid={intercomIDs.CURRENT_WORKSPACE_NAV_CREATE_NEW_BOARD}
      // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
      onClick={() => {
        showCreateBoardModal({
          selectedParentBoard: BOARDS_SELECT_EMPTY_OPTION,
          trackLocation: 'side-nav-extension-end-button',
        });
      }}
      prefix={<PlusIcon size="sm" />}
      size="medium"
    >
      New board
    </Button>
  );
});

CurrentWorkspaceNavCreateBoardButton.displayName = 'CreateBoardButtonEnd';
